import { Tooltip } from "@mantine/core";
import { useColors } from "../../../hooks/colors/useColors";
import {
  IconBrandFacebook,
  IconBrandTwitter,
  IconBrandWhatsapp,
  IconMail,
} from "@tabler/icons";
import { useTranslation } from "next-i18next";
import { MyH1 } from "../../UI/my-h1/MyH1";
import { BlogDataProps } from "../../../hooks/react-query/useBlogList";

export function BlogShare(props: BlogDataProps) {
  const { blog } = props;
  const { colors } = useColors();
  const { t } = useTranslation("common");

  function openPopupShare(url: string) {
    window.open(url, "MyWindow", "width=600,height=300");
    return false;
  }

  return (
      <div className="flex flex-col justify-center items-center mt-8 mb-4">
        <MyH1 color={colors.primary} className="text-center">
          {t("blog-like")}
        </MyH1>

        <div className="flex gap-4 ml-4">
          <Tooltip label="Facebook">
            <a
                href="#"
                onClick={() =>
                    openPopupShare(
                        `https://www.facebook.com/sharer/sharer.php?u=psiworks.pt/blog/${blog.urlSlug}`
                    )
                }
            >
              <IconBrandFacebook size={40} color="#1877f2" />
            </a>
          </Tooltip>
          <Tooltip label="Twitter">
            <a
                href="#"
                onClick={() =>
                    openPopupShare(
                        `http://twitter.com/share?text=${blog.title}&url=psiworks.pt/blog/${blog.urlSlug}`
                    )
                }
            >
              <IconBrandTwitter size={40} color="#1da1f2" />
            </a>
          </Tooltip>
          {/*<Tooltip label="Instagram">*/}
          {/*  <a*/}
          {/*    href="#"*/}
          {/*    onClick={() =>*/}
          {/*      openPopupShare(*/}
          {/*        `https://www.instagram.com/sharer.php?u=psiworks.pt/blog/${blog.urlSlug}`*/}
          {/*      )*/}
          {/*    }*/}
          {/*  >*/}
          {/*    <IconBrandInstagram size={40} color="#405de6" />*/}
          {/*  </a>*/}
          {/*</Tooltip>*/}
          <Tooltip label="Whatsapp">
            <a
                href="#"
                onClick={() =>
                    openPopupShare(
                        `https://api.whatsapp.com/send?text=${blog.title} https://psiworks.pt/blog/${blog.urlSlug}`
                    )
                }
            >
              <IconBrandWhatsapp size={40} color="#128c7e" />
            </a>
          </Tooltip>
          <Tooltip label="Email">
            <a
                href={`mailto:abc@example.com?subject=PsiWorks - ${blog.title}&body=${blog.title} https://psiworks.pt/blog/${blog.urlSlug}`}
            >
              <IconMail size={40} color={colors.primary} />
            </a>
          </Tooltip>
        </div>
      </div>
  );
}

// import { Grid, Tooltip } from "@mantine/core";
// import { useColors } from "../../../hooks/colors/useColors";
// import {
//   IconBrandFacebook,
//   IconBrandTwitter,
//   IconBrandWhatsapp,
//   IconMail,
// } from "@tabler/icons";
// import { useTranslation } from "next-i18next";
//
// import { localServerUrl } from "../../../constants/env";
// import { Post } from "../../../types/graphql";
//
// export function BlogShare({ blog }: { blog: Post }) {
//   const { colors } = useColors();
//   const { t } = useTranslation("common");
//
//   function openPopupShare(url: string) {
//     window.open(url, "MyWindow", "width=600,height=300");
//     return false;
//   }
//
//   return (
//     <Grid className="mt-8 mb-4 mx-auto">
//       <Grid.Col
//         span={{ base: 12, md: 6 }}
//         className="flex gap-4 ml-4 md:justify-end "
//       >
//         <h2
//           style={{ color: colors.primary, lineHeight: "inherit" }}
//           className="text-3xl m-0"
//         >
//           {t("blog-like")}
//         </h2>
//       </Grid.Col>
//
//       <Grid.Col span={{ base: 12, md: 6 }} className="flex gap-4 ml-4">
//         <Tooltip label="Facebook">
//           <span
//             className="hover:cursor-pointer"
//             onClick={() =>
//               openPopupShare(
//                 `https://www.facebook.com/sharer/sharer.php?u=${localServerUrl}/blog/${blog.slug}`
//               )
//             }
//           >
//             <IconBrandFacebook size={40} color="#1877f2" />
//           </span>
//         </Tooltip>
//         <Tooltip label="Twitter">
//           <span
//             className="hover:cursor-pointer"
//             onClick={() =>
//               openPopupShare(
//                 `http://twitter.com/share?text=${blog.title}&url=${localServerUrl}/blog/${blog.slug}`
//               )
//             }
//           >
//             <IconBrandTwitter size={40} color="#1da1f2" />
//           </span>
//         </Tooltip>
//         <Tooltip label="Whatsapp">
//           <span
//             className="hover:cursor-pointer"
//             onClick={() =>
//               openPopupShare(
//                 `https://api.whatsapp.com/send?text=${blog.title} ${localServerUrl}/blog/${blog.slug}`
//               )
//             }
//           >
//             <IconBrandWhatsapp size={40} color="#128c7e" />
//           </span>
//         </Tooltip>
//         <Tooltip label="Email">
//           <a
//             href={`mailto:abc@example.com?subject=PsiWorks - ${blog.title}&body=${blog.title} ${localServerUrl}/blog/${blog.slug}`}
//           >
//             <IconMail size={40} color={colors.primary} />
//           </a>
//         </Tooltip>
//       </Grid.Col>
//     </Grid>
//   );
// }
